import { render, staticRenderFns } from "./TransferFacilityDialog.vue?vue&type=template&id=370f1a0d"
import script from "./TransferFacilityDialog.vue?vue&type=script&lang=js"
export * from "./TransferFacilityDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports